import { parseTemplate } from 'url-template';
import { ErrorResponse } from '~/Api/User/ProductGroup/LtMaxPrice/ErrorResponse';
import { LtMaxPrice } from '~/Api/User/ProductGroup/LtMaxPrice/LtMaxPrice';
import { mapLtMaxPrice } from '~/Api/User/ProductGroup/LtMaxPrice/mapLtMaxPrice';
import ApiClient, { ApiClientErrorResponse } from '~/ApiClient';

export interface Result {
	ltMaxPrice: LtMaxPrice;
}

export const findLtMaxPrice = async (client: ApiClient, userId: string, groupId: string): Promise<Result> => {
	const url = parseTemplate('users/{userId}/product-groups/{groupId}/lt-max-price');

	try {
		const request = await client.fetch(url.expand({ userId, groupId }));
		const response = await request.json();
		return { ltMaxPrice: mapLtMaxPrice(response.ltMaxPrice) };
	} catch (error) {
		throw error instanceof ApiClientErrorResponse
			? new ErrorResponse(error.request, error.statusCode, error.errors)
			: error;
	}
};
